import { gql } from '@apollo/client'

export const GATEWAYS_LIST_QUERY = gql`
  query Gateways {
    gateways {
      basicDetails {
        name
        entityType
        entity
        gatewayId
        entityCode
        displayEntityCode
      }
      credential {
        gatewaysType
      }
    }
  }
`

export const GATEWAY_QUERY = gql`
  query Gateway($gatewayId: String!) {
    gateway(gatewayId: $gatewayId) {
      basicDetails {
        name
        entityType
        entity
        entityId
        gatewayId
        description
        supportedCurrencies
        entityCode
        displayEntityCode
        active
        walletType
        paymentType
      }
      credential {
        gatewaysType
        credentialMode
      }
      credentialModeDetails {
        merchantId
        terminalId
        username
        password
        apiKey
      }
    }
  }
`

export const GATEWAY_GENERATE_MUTATION = gql`
  mutation GenerateGateway($input: GatewayInput!) {
    generateGateway(input: $input) {
      message
    }
  }
`
export const GATEWAY_MODIFY_MUTATION = gql`
  mutation ModifyGateway($input: GatewayInput!, $gatewayID: String!) {
    modifyGateway(input: $input, gatewayID: $gatewayID) {
      message
    }
  }
`

export const GET_GATE_WAY_LIST = gql`
  query GatewayList($input: GatewayListInput!) {
    gatewayList(input: $input) {
      ID
      gateWayType
      gateWayNumber
    }
  }
`
